<div class="header-bar">
  <h1>Latest Interactions by Organisation</h1>
</div>
<div class="content-container">
  <div style="display: flex; flex-direction: row">
    <!--      <div style="flex-shrink: 1" *ngIf="!noAdd">-->
    <!--        <button [disabled]="!organisationId" class="btn-to-right" icon="fa ui-icon-add" type="button" pButton (click)="addInteraction()" label="Add Interaction"></button>-->
    <!--      </div>-->
  </div>
  <!--    <table class="interactions-table">-->
  <!--      <thead>-->
  <!--      <tr>-->
  <!--        <th>Name</th>-->
  <!--        <th>Type</th>-->
  <!--        <th>Created</th>-->
  <!--        <th>Channel</th>-->
  <!--        <th>Added By</th>-->
  <!--        <th>Note</th>-->
  <!--        <th>Category</th>-->
  <!--      </tr>-->
  <!--      </thead>-->
  <!--      <tbody>-->
  <!--      <tr *ngFor="let interaction of interactions">-->
  <!--        <td class="white-space-nowrap">{{ interaction.organisation.name }}</td>-->
  <!--        <td>{{ interaction.organisation.organisationTypeName }}</td>-->
  <!--        <td class="white-space-nowrap">{{ interaction.addedDate | date: 'EEE dd MMM HH:mm' }}</td>-->
  <!--        <td>{{ interaction.interactionChannel.name }}</td>-->
  <!--        <td>{{ interaction.addedByUser }}</td>-->
  <!--        <td><div style="overflow-wrap: anywhere;">{{ interaction.note }}</div></td>-->
  <!--        <td>{{ interaction.interactionCategory.name }}</td>-->
  <!--      </tr>-->
  <!--      </tbody>-->
  <!--    </table>-->

  <p-table
    [value]="page.items"
    [lazy]="true"
    [rows]="25"
    [responsive]="true"
    [paginator]="true"
    [rowsPerPageOptions]="[25, 50, 100]"
    [pageLinks]="8"
    [totalRecords]="page.total"
    (onLazyLoad)="onGridLazyLoad($event)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="organisation.name">Name</th>
        <th pSortableColumn="organisation.organisationTypeName">Type</th>
        <th pSortableColumn="addedDate">Added</th>
        <th pSortableColumn="interactionChannel.name">Channel</th>
        <th pSortableColumn="addedByUser">Added By</th>
        <th pSortableColumn="note">Note</th>
        <th pSortableColumn="interactionCategory.name">Category</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <span>{{ item.organisation.name }}</span>
        </td>
        <td>
          <span>{{ item.organisation.organisationTypeName }}</span>
        </td>
        <td>
          <span
            [ngClass]="{
              'warning-amber': item.warningLevel == 1,
              'warning-red': item.warningLevel == 2
            }"
          >
            {{ item.addedDate | date : 'EEE dd MMM HH:mm' }}
          </span>
        </td>
        <td>
          <span>{{ item.interactionChannel.name }}</span>
        </td>
        <td>
          <span>{{ item.addedByUser }}</span>
        </td>
        <td>
          <div
            tooltipStyleClass="itooltip"
            pTooltip="{{ item.note }}"
            tooltipPosition="bottom"
            style="max-height: 80px; text-overflow: ellipsis; white-space: normal"
          >
            <div>{{ item.note }}</div>
          </div>
        </td>
        <td>
          <span>{{ item.interactionCategory.name }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- DATATABLES DEPRECATED ---
  <p-dataTabl [value]="page.items" [lazy]="true" [rows]="25" [responsive]="true" [paginator]="true"
               [rowsPerPageOptions]="[25,50,100]" [pageLinks]="8" [editable]="tru" [totalRecords]="page.total"
               (onLazyLoad)="onGridLazyLoad($event)">

    <p-column [style]="{'width': '320px' }" field="Name" header="Name" [sortable]="tru" [editable]="false">
      <ng-template let-item="rowData" pTemplate="body">
        <span>{{ item.organisation.name }}</span>
      </ng-template>
    </p-column>

    <p-column [style]="{'width': '80px' }" header="Type" [sortable]="false" [editable]="false">
      <ng-template let-item="rowData" pTemplate="body">
        <span>{{ item.organisation.organisationTypeName }}</span>
      </ng-template>
    </p-column>

    <p-column [style]="{'width': '150px' }" field="addedDate" header="Added" [sortable]="tru" [editable]="false">
      <ng-template let-item="rowData" pTemplate="body">
        <span [ngClass]="{ 'warning-amber': item.warningLevel == 1, 'warning-red': item.warningLevel == 2 }" >
          {{ item.addedDate | date: 'EEE dd MMM HH:mm' }}
        </span>
      </ng-template>
    </p-column>

    <p-column [style]="{'width': '140px' }" header="Channel" [sortable]="false" [editable]="false">
      <ng-template let-item="rowData" pTemplate="body">
        <span>{{ item.interactionChannel.name }}</span>
      </ng-template>
    </p-column>

    <p-column [style]="{'width': '240px' }" header="Added By" [sortable]="false" [editable]="false">
      <ng-template let-item="rowData" pTemplate="body">
        <span>{{ item.addedByUser }}</span>
      </ng-template>
    </p-column>

    <p-column [style]="{'width': '400px' }" header="Note" [sortable]="false" [editable]="false">
      <ng-template let-item="rowData" pTemplate="body">
        <div tooltipStyleClass="itooltip" pTooltip="{{item.note}}" tooltipPosition="bottom"
              style="max-height: 80px; text-overflow: ellipsis; white-space: normal;">
          <div>{{ item.note }}</div>
        </div>
      </ng-template>
    </p-column>

    <p-column [style]="{'width': '140px' }" header="Category" [sortable]="false" [editable]="false">
      <ng-template let-item="rowData" pTemplate="body">
        <span>{{ item.interactionCategory.name }}</span>
      </ng-template>
    </p-column>

  </p-dataTable>

  --->

  <div *ngIf="loading" class="grid">
    <div class="col-12" style="text-align: center; margin-top: 20px">
      <i class="fa fa-spinner fa-spin fa-2x"></i> Loading Interactions...
    </div>
  </div>
</div>
